import axios from './../../config/axios';

/**
 * 
 * @param {Object} payload The query string as an Object
 * @param {string} payload.date The date in ISO format example: 2020-01-01
 */
export function searchExchangeRates(payload) {
    return axios().get(`/ledger/exchange-search`, { params: payload });
}

export function storeExchangeRate(data) {
    return axios().post(`/ledger/exchange-rates`, data);
}

export default {
    searchExchangeRates,
    storeExchangeRate
}